import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
// Bootstrap 5
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Iconify Vue
import { Icon } from '@iconify/vue';
// SimpleBar CSS
import 'simplebar/dist/simplebar.min.css';
// Theme CSS (custom theme styles)
import '@/assets/css/vendor.min.css';
import '@/assets/css/icons.min.css';
import '@/assets/css/app.min.css';
// Tailwind CSS (with tw- prefix to avoid conflicts with Bootstrap)
import '@/assets/css/tailwind.css';
const app = createApp(App);
// Register Icon component globally as IconifyIcon (multi-word for ESLint)
app.component('IconifyIcon', Icon);
// Use router
app.use(router);
app.mount('#app');
